<template>
  <div class="outer-wrapper">
    <div v-if="!$session.loading && !($session.user && $session.user.username) && this.$route.name === 'Landing'" style="width: 100%; height: 100%;">
      <router-view></router-view>
    </div>
    <transition :duration="300" name="appfade">
      <div v-if="$session.loading" class="main-loading">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    </transition>
    <transition :duration="1000" name="applogin">
      <login v-if="!($session.user && $session.user.username && $session.jwtExpiration) && (this.$route.name !== 'Landing' || (this.$route.name === 'Landing' && $session.showLogin))"></login>
    </transition>
    <transition :duration="1000" name="appfade">
      <div class="app" v-if="$session.user && $session.user.username">
        <AppHeader/>
        <div class="app-body">
          <Sidebar />
          <main class="main">
            <router-view></router-view>
          </main>
        </div>
        <footer class="app-footer">
          Test Stand Portal &copy; 2017 Highlight Industries.
        </footer>
      </div>
    </transition>
    <modal-view />
  </div>
</template>

<style lang="scss">
.outer-wrapper {
  width: 100%;
  height: 100%;
}
.main-loading {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
  font-size: 30px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(255,255,255,0.6);
}
body, html {
  height: 100%;
}
div.app {
  height: 100%;
}
</style>

<script>
import AppHeader from '@/components/Header'
import Sidebar from '@/components/Sidebar'
import Breadcrumb from '@/components/Breadcrumb'
import Login from '@/components/Login'

export default {
  name: 'app',
  components: {
    AppHeader,
    Sidebar,
    Breadcrumb,
    Login
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?c736eb1c